const AssignBatchVisibleColumn = [
    {
        title: "ID",
        field: "ID",
        locked: false,
        // filter: "numeric",
        // customFilterType: 'CustomNumericText',
        width: "120",
        show: true,
    },
    {
        title: "Employee Id",
        field: "EmployeeId",
        locked: false,
        filter: "text",
        width: "170",
        show: true,
    },
    {
        title: "Job Order No",
        field: "Job_Order_Number",
        locked: false,
        filter: "text",
        // customFilterType: 'CustomNumericText',
        width: "190",
        show: true,
    },
    {
        title: "Budget Account No",
        field: "Budget_Acct_No",
        locked: false,
        filter: "text",
        width: "200",
        show: true,
    },
    {
        title: "HR Control No",
        field: "HR_CONTROL",
        locked: false,
        filter: "text",
        // customFilterType: 'CustomNumericText',
        width: "200",
        show: true,
    },
    {
        title: "First Name",
        field: "FirstName",
        locked: false,
        filter: "text",
        // customFilterType: 'CustomNumericText',
        width: "190",
        show: true,
    },
    {
        title: "Last Name",
        field: "LastName",
        locked: false,
        filter: "text",
        width: "190",
        show: true,
    },
    {
        title: "Middle Name",
        field: "MiddleName",
        locked: false,
        filter: "text",
        width: "170",
        show: true,
    },
    {
        title: "DOB",
        field: "DOB",
        locked: false,
        filter: "date",
        format: "MM/DD/yyyy",
        editor: "date",
        width: "160",
        show: true,
    },
    {
        title: "SSN",
        field: "SSN",
        locked: false,
        filter: "text",
        width: "170",
        show: true,
    },
    {
        title: "Mailing Address",
        field: "Ml_Add_Ln1", //"MailingAddress",
        locked: false,
        filter: "text",
        width: "250",
        show: true,
    },
    {
        title: "City",
        field: "Ml_Add_City", //"City",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "State",
        field: "Ml_Add_State", //"State",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "ZIP",
        field: "Ml_Add_Zip", //"ZIP",
        locked: false,
        filter: "numeric",
        customFilterType: 'CustomNumericText',
        width: "150",
        show: true,
    },
    {
        title: "Contact No",
        field: "PhoneNo", //"ContactNo",
        locked: false,
        filter: "text",
        // customFilterType: 'CustomNumericText',
        width: "180",
        show: true,
    },
    {
        title: "From PositionTitle",
        field: "Position_title",
        locked: false,
        filter: "text",
        width: "190",
        show: true,
    },
    {
        title: "To PositionTitle",
        field: "To_Position_Title",
        locked: false,
        filter: "text",
        width: "190",
        show: true,
    },
    {
        title: "From Grade",
        field: "Pay_Grade",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "To Grade",
        field: "To_Pay_Grade",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "From Rate",
        field: "Rate",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "To Rate",
        field: "To_Rate",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "From Step",
        field: "Step",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "To Step",
        field: "To_Step",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "From Salary",
        field: "Salary",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
    {
        title: "To Salary",
        field: "To_Salary",
        locked: false,
        filter: "text",
        width: "150",
        show: true,
    },
];

export default AssignBatchVisibleColumn;
